import { useCallback, useState } from "react";

const KEY = "vdg_favoritos";

const leer = () => {
  try {
    const data = JSON.parse(localStorage.getItem(KEY));
    return data && typeof data === "object" ? { canciones: [], libros: [], ...data } : { canciones: [], libros: [] };
  } catch {
    return { canciones: [], libros: [] };
  }
};

// Hook de favoritos por tipo ("canciones" | "libros"). Persiste en localStorage del visitante.
export const useFavoritos = (tipo) => {
  const [ids, setIds] = useState(() => leer()[tipo]);

  const toggle = useCallback(
    (id) => {
      const data = leer();
      const lista = data[tipo];
      const nueva = lista.includes(id) ? lista.filter((x) => x !== id) : [...lista, id];
      data[tipo] = nueva;
      localStorage.setItem(KEY, JSON.stringify(data));
      setIds(nueva);
      return nueva.includes(id);
    },
    [tipo]
  );

  return [ids, toggle];
};

// Comparte con el menú nativo del dispositivo; si no existe, copia el enlace.
export const compartir = async ({ titulo, texto, url }) => {
  if (navigator.share) {
    try {
      await navigator.share({ title: titulo, text: texto, url });
      return "shared";
    } catch {
      return "cancelled";
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "error";
  }
};
